/**
 * Rich table toolbar
 * Component holds a search field and buttons to refresh data and create new entity
 **/
import { RichTableToolbarComponent } from './RichTableToolbar.types';
import { Flexbox, Icon, Tooltip, Typography } from '@hiiretail/synergy-ui';
import { SearchBar, ToolbarTitle, ToolbarWrapper } from '../RichTable.styles';
import { AccessControl } from '../../AccessControl/AccessControl';
import { CreateButton } from '../../Breadcrumbs/buttons/CreateButton/CreateButton';

export const RichTableToolbar: RichTableToolbarComponent = ({
  searchFieldLabel,
  title,
  onSearchChange,
  hideSearch = false,
  permissions,
  createButtonTitle,
  onCreateButtonClick,
  createButtonPermission,
}) => {
  return (
    <ToolbarWrapper container alignItems="center" justifyContent="space-between" item>
      <Flexbox item flex="0.1 1 auto">
        <ToolbarTitle variant="header3">{title}</ToolbarTitle>
      </Flexbox>
      <Flexbox container item flex="1 1 auto" justifyContent="flex-end">
        {!hideSearch && (
          <AccessControl
            permission={permissions.list}
            renderIfNoAccess={
              <Flexbox item flex="1 1 auto">
                <Tooltip
                  title={
                    <Flexbox container direction="column">
                      <Typography variant="caption" color={() => 'white'}>
                        You do not have permissions to perform this action.
                      </Typography>
                      <Typography variant="caption" color={() => 'white'}>
                        Required permissions: {/*@ts-ignore*/}
                        <Typography variant="caption" weight="bold" color={() => 'white'}>
                          {permissions.list}
                        </Typography>
                      </Typography>
                    </Flexbox>
                  }
                >
                  <SearchBar
                    fullWidth
                    disabled
                    hideLabel
                    name="search"
                    label={searchFieldLabel}
                    placeholder={searchFieldLabel}
                    leadingIcon={<Icon.Search color={() => '#a8a8a8'} />}
                  />
                </Tooltip>
              </Flexbox>
            }
          >
            <Flexbox item flex="0.3 1 auto">
              <SearchBar
                fullWidth
                name="search"
                label={searchFieldLabel}
                placeholder={searchFieldLabel}
                onChange={(event) => {
                  onSearchChange(event.target.value.trim());
                }}
                hideLabel
                leadingIcon={<Icon.Search />}
              />
            </Flexbox>
          </AccessControl>
        )}
        {createButtonTitle && (
          <Flexbox item container justifyContent="flex-end" flex="0.1 1 auto">
            <CreateButton
              title={createButtonTitle}
              onClick={onCreateButtonClick as () => void}
              permission={createButtonPermission as string}
            />
          </Flexbox>

        )}
      </Flexbox>
    </ToolbarWrapper>
  );
};
